import React from 'react';
import { CompanyDashboardProps, fillColor } from '../constants';
interface CustomizedTickProps {
  x: number;
  y: number;
  payload: {
    value: string | number;
    [key: string]: unknown;
  };
}
export const CustomTick = (props: CustomizedTickProps) => {
  const { x, y, payload } = props;

  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={20}
        y={0}
        dy={18}
        textAnchor={CompanyDashboardProps.END}
        fill={fillColor}>
        {payload.value}
      </text>
    </g>
  );
};
